<form [formGroup]="reportForm" *ngIf="reportForm">
  <div *ngIf="reportType === 'spider'" class="row d-flex justify-content-center my-3">
    <div class="col-12">
      <div class="form-group row">
        <label for="maxSpider" class="col-sm-2 col-form-label">Max</label>
        <div class="col-sm-10">
          <input formControlName="MAX" type="number" class="form-control" id="maxSpider" style="width: 15%;">
        </div>
      </div>
      <div class="form-group">
        <label for="spiderDescription">คำอธิบายรายงานแบบทดสอบ</label>
        <textarea formControlName="TEMPLATE_DES" class="form-control" id="spiderDescription" rows="3"
          maxlength="1500"></textarea>
        <p class="text-right">{{ reportForm.value.TEMPLATE_DES.length | number }}/1,500</p>
      </div>
    </div>

    <div class="col-12">
      <h3 class="text-center my-4">ลักษณะทางจิตวิทยา</h3>
      <div *ngFor="let r of reportForm.get('PSY_BLOCKS')['controls']; let i = index" formArrayName="PSY_BLOCKS">
        <div [formGroupName]="i" class="box mt-4">
          <button *ngIf="i !== 0" mat-mini-fab class="img close-btn" (click)="removeGroup(i, true)"
            [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
          <div class="form-group row" style="margin-top: 60px;">
            <label for="psycoGroupName" class="col-sm-3 col-form-label text-right">ชื่อกลุ่มลักษณะทางจิตวิทยา</label>
            <div class="col-sm-9">
              <input formControlName="PSY_GROUP_NAME" type="text" class="form-control" id="psycoGroupName">
            </div>
          </div>

          <div class="form-group row">
            <label for="color" class="col-3 col-form-label text-right">สี</label>
            <div class="col-sm-9">
              <input formControlName="PSY_GROUP_COLOR" type="color" id="color" class="form-control" style="width: 20%;">
              <small *ngIf="!r.value.PSY_GROUP_COLOR" class="col-form-label" class="text-danger">
                ยังไม่ได้ใส่สี ✖
              </small>
              <small *ngIf="r.value.PSY_GROUP_COLOR" class="col-form-label" class="text-success">
                ใส่สีเรียบร้อย ✔
              </small>
            </div>
          </div>

          <div *ngFor="let data of r.get('PSY_DATA')['controls']; let j = index" formArrayName="PSY_DATA">
            <div [formGroupName]="j" class="box mt-4">
              <button *ngIf="j !== 0" mat-mini-fab class="img close-group-btn"
                (click)="removePsychoGroup(r.get('PSY_DATA') ,j)"
                [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
              <div class="form-group row" style="margin-top: 40px;">
                <label for="psycoGroupType" class="col-sm-4 col-form-label">ลักษณะทางจิตวิทยา</label>
                <div class="col-sm-8">
                  <input formControlName="PSY_NAME" type="text" class="form-control" id="psycoGroupName">
                </div>
              </div>

              <div class="form-group">
                <label for="spiderDescription" class="col-form-label">คำอธิบายลักษณะทางจิตวิทยา</label>
                <textarea formControlName="DETAIL_PSY" class="form-control" id="spiderDescription" rows="3"
                  maxlength="1500"></textarea>
                <p class="text-right">{{ reportForm.value.PSY_BLOCKS[i].PSY_DATA[j].DETAIL_PSY.length | number }}/1,500</p>
              </div>

              <div class="row justify-content-center">
                <lifedi-btn *ngIf="!reportForm.value.PSY_BLOCKS[i].PSY_DATA[j].CAL" lable="การคำนวณ"
                  (click)="openCalculateModal(r.get('PSY_DATA'), i, j, false)"
                  customStyle="background-color: #060E9F; color: #FFF; margin: 20px 5px 20px 0px; padding: 0 30px;">
                </lifedi-btn>
              </div>

              <div class="row justify-content-center">
                <lifedi-btn *ngIf="reportForm.value.PSY_BLOCKS[i].PSY_DATA[j].CAL" lable="แก้ไขการคำนวณ"
                  (click)="openCalculateModal(r.get('PSY_DATA'), i, j, true)"
                  customStyle="background-color: #060E9F; color: #FFF; margin: 20px 5px 20px 0px; padding: 0 30px;">
                </lifedi-btn>
              </div>

              <div class="row justify-content-center">
                <small *ngIf="!reportForm.value.PSY_BLOCKS[i].PSY_DATA[j].CAL" class="col-form-label"
                  class="text-danger">
                  ยังไม่ได้ใส่วิธีการคำนวณ ✖
                </small>
                <small *ngIf="reportForm.value.PSY_BLOCKS[i].PSY_DATA[j].CAL" class="col-form-label"
                  class="text-success">
                  ใส่วิธีการคำนวณแล้ว ✔
                </small>
              </div>

            </div>
          </div>
          <button (click)="addPsychoGroup(r.get('PSY_DATA'))" mat-mini-fab class="img"
            [style.backgroundImage]="'url(\'../../../../assets/add.png\')'">
          </button>
        </div>

      </div>
      <div class="row justify-content-center">
        <lifedi-btn lable="เพิ่มกลุ่มลักษณะทางจิตวิทยา" (click)="addGroup(reportType)"
          customStyle="background-color: #00AF80; color: #FFF; margin: 20px 5px 20px 0px; padding: 0 30px;">
        </lifedi-btn>
      </div>
    </div>
  </div>
</form>
